import { useEffect, useState } from "react";
import { listTeamMembers } from "../../../api/clientTeamApi";
import MidpointMediaSetupPanel from "../../../components/midpointMedia/admin/MidpointMediaSetupPanel";
import useMidpointMediaAdminView from "../../../hooks/useMidpointMediaAdminView";
import "../../../styles/midpointMediaAdmin.css";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const DEMO_PEOPLE = ["Ana Pérez", "Luis Gómez", "Priya Shah", "Dan Lopez"];
const WINDOWS = {
  "Ana Pérez": ["am", "am", "am", "", "am", "", ""],
  "Luis Gómez": ["", "pm", "pm", "pm", "pm", "", ""],
  "Priya Shah": ["eve", "", "eve", "eve", "", "am", ""],
  "Dan Lopez": ["am", "am", "am", "am", "am", "", ""],
};

const INSTRUCTIONS = {
  title: "Make employee schedules live",
  summary:
    "This board is a working preview of weekly coverage. To persist real shifts, add a client_user_schedules table (client_user_id, weekday, window, timezone) and a People schedules API under /api/client/views/:id/midpoint-media/schedules.",
  steps: [
    "Keep using People → Accounts to invite employees (that part is already live).",
    "Add migration client_user_schedules with weekday (0–6), window (am|pm|eve), and timezone (America/Caracas for Venezuela staff).",
    "Expose GET/PUT /api/client/views/:clientViewId/midpoint-media/schedules guarded by manage_iam.",
    "Replace the demo WINDOWS map in this page with API data. Until then, the grid is illustrative only.",
  ],
  env: [],
};

function windowLabel(value) {
  if (value === "am") return "08–12";
  if (value === "pm") return "12–16";
  if (value === "eve") return "16–20";
  return "";
}

export default function MidpointMediaAdminPeopleSchedulesPage() {
  const { clientViewId } = useMidpointMediaAdminView();
  const [names, setNames] = useState(DEMO_PEOPLE);

  useEffect(() => {
    if (!clientViewId) return undefined;
    listTeamMembers(clientViewId)
      .then((body) => {
        const members = (body?.members || body?.users || []).map((member) =>
          [member.firstName || member.first_name, member.lastName || member.last_name]
            .filter(Boolean)
            .join(" ") || member.email
        );
        if (members.length) setNames(members.slice(0, 8));
      })
      .catch(() => {});
    return undefined;
  }, [clientViewId]);

  return (
    <div className="mm-admin-page">
      <header>
        <p className="mm-admin-kicker">People · Schedules</p>
        <h1>Weekly coverage</h1>
        <p className="mm-admin-lead">
          Venezuela time (UTC−4). This is a demo of how engineering, support, and hiring coverage
          will appear once shifts are stored.
        </p>
      </header>
      <MidpointMediaSetupPanel instructions={INSTRUCTIONS} />
      <section className="mm-admin-card">
        <div className="mm-admin-badge mm-admin-badge--demo">Demo board</div>
        <div className="mm-admin-schedule" style={{ marginTop: 12 }}>
          <div className="mm-admin-schedule__head">Employee</div>
          {DAYS.map((day) => (
            <div key={day} className="mm-admin-schedule__head">
              {day}
            </div>
          ))}
          {names.map((name) => {
            const row = WINDOWS[name] || WINDOWS[DEMO_PEOPLE[names.indexOf(name) % DEMO_PEOPLE.length]];
            return (
              <div key={name} style={{ display: "contents" }}>
                <div className="mm-admin-schedule__cell">
                  <strong>{name}</strong>
                </div>
                {DAYS.map((day, index) => {
                  const value = row?.[index] || "";
                  return (
                    <div
                      key={`${name}-${day}`}
                      className={`mm-admin-schedule__cell${value ? " on" : ""}`}
                    >
                      {windowLabel(value) || "—"}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
